module.exports = __webpack_public_path__ + "img/3.39f22f19.png";